import { AppearanceToggle } from "@/react/components/SettingsApp/Site/Pages/Edit/Design/AppearanceToggle";
import { useBuilderStore } from "../Hooks/useBuilderStore";
import { ThemeSelector } from "./ThemeSelector";
import { Tokens } from "./Tokens";

export const DefaultSiteThemesView = () => {
  const { appearance, toggleAppearance } = useBuilderStore(state => ({
    appearance: state.appearance,
    toggleAppearance: state.toggleAppearance,
  }));

  return (
    <>
      <AppearanceToggle
        currentAppearance={appearance}
        onAppearanceChange={toggleAppearance}
      />
      <ThemeSelector />
      <Tokens />
    </>
  );
};
